export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кеше"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бүгін"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүйсенбі"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сейсенбі"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәрсенбі"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бейсенбі"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жұма"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сенбі"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жексенбі"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["қаңтар"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ақпан"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["наурыз"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["сәуір"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["мамыр"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["маусым"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["шілде"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["тамыз"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["қыркүйек"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["қазан"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["қараша"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["желтоқсан"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Әкімші"])}
}